import { useCallback } from 'react';
// import { openNewWebview } from '@/utils/bridge';
import { reportClick } from '@/utils/report';
import EmptyList from './EmptyList';
import LoadingList from './LoadingList';
import {
  ACT_UNFINISHED_STATUS,
  ACT_NOT_RECEIVED_STATUS,
  ACT_RECEIVED_STATUS,
  ACT_ENDED_STATUS,
  ACT_TIMEOUT_UNFINISHED_STATUS,
  ACT_TIMEOUT_NOT_RECEIVED_STATUS,
  ACT_DEVICE_CONFIG,
  ACT_MAX_REWARD_MONTH_NUM,
} from '../../config';
import styles from '../index.less';
import { jumpToPageByH5 } from '@/utils/fn';

const NinthAnniversaryDeviceList = ({ deviceList, pageName, loading }) => {
  const handleJumpToDetail = useCallback(
    (sn, xm) => {
      reportClick({
        page_name: pageName,
        button_name: 'to_detail',
        sn,
      });
      // openNewWebview({
      //   url: `${window.location.origin}/acts/ninthAnniversary/detail/${sn}?cm=${xm}`,
      // });
      jumpToPageByH5(`/acts/ninthAnniversary/detail/${sn}?cm=${xm}`);
    },
    [pageName]
  );

  const renderButtonText = useCallback((status, rewardMonthNum) => {
    let text = '--';
    switch (status) {
      case ACT_UNFINISHED_STATUS:
        text = '去完成';
        break;
      case ACT_NOT_RECEIVED_STATUS:
        text = '待领取';
        break;
      case ACT_TIMEOUT_UNFINISHED_STATUS:
        text = '超时未完成';
        break;
      case ACT_TIMEOUT_NOT_RECEIVED_STATUS:
        text = '超时未领取';
        break;
      case ACT_RECEIVED_STATUS:
      case ACT_ENDED_STATUS:
        text = `${rewardMonthNum}/${ACT_MAX_REWARD_MONTH_NUM}`;
        break;
      default:
        break;
    }
    return text;
  }, []);

  const renderDeviceTipText = useCallback((st, adt) => {
    let text = '';
    switch (st) {
      case ACT_UNFINISHED_STATUS:
        text = `*请在${adt}前完成累计7天在线达标，否则将失去年卡资格`;
        break;
      case ACT_NOT_RECEIVED_STATUS:
        text = `*请在${adt}前领取，否则将视为放弃迅雷会员年卡资格`;
        break;
      case ACT_TIMEOUT_UNFINISHED_STATUS:
        text = `*您未在${adt}前完成累计7天在线达标，已失去年卡资格`;
        break;
      case ACT_TIMEOUT_NOT_RECEIVED_STATUS:
        text = `*您未在${adt}前领取年卡资格`;
        break;
      case ACT_RECEIVED_STATUS:
      case ACT_ENDED_STATUS:
        text = `*权益打卡有效期：${adt}（390天）`;
        // break;
        // text = `*权益打卡有效期：${adt}`;
        break;
      default:
        break;
    }
    return text;
  }, []);
  return (
    <div>
      {deviceList?.length > 0 ? (
        <ul className={styles.deviceList}>
          {deviceList.map((item, index) => {
            const { sn, dt, st, rmn, adt, xm } = item;
            const deviceConfig = ACT_DEVICE_CONFIG[dt] || {};
            return (
              <li
                key={index}
                className={styles[`status-${st}`]}
                onClick={() => handleJumpToDetail(sn, xm)}
              >
                <div className={styles.deviceInfo}>
                  <div className={styles.deviceTextInfo}>
                    <p className={styles.baseInfo}>
                      <em>{dt}</em>
                      {sn}
                    </p>
                    <p className={`${styles.reward} ${styles[deviceConfig.prefix]}`}>
                      {deviceConfig.reward}年卡资格
                    </p>
                  </div>
                  <button className={styles.deviceBtn}>{renderButtonText(st, rmn)}</button>
                </div>
                <div className={styles.deviceTip}>{renderDeviceTipText(st, adt)}</div>
              </li>
            );
          })}
        </ul>
      ) : loading ? (
        <LoadingList />
      ) : (
        <EmptyList />
      )}
    </div>
  );
};
export default NinthAnniversaryDeviceList;
